import Loader from 'components/Loader';
import { useEffect, useState } from 'react';
import { formatCurrency} from 'utils/utils';
import ShowMoreContent from './ShowMoreContent';

export function BasketContentCartItem(props) {
    const { item, actions } = props;
    const [loading, setloading] = useState(false);

    const shortBasketitemTitle = () => {
        const basketTitle = item.title;
        return basketTitle.length > 28 ? `${basketTitle.substring(0, 28)}...` : basketTitle;
    };

    return <Loader isLoading={loading}>
        <div className="row gap-24 pt-32" id="product-row-@item.Id">
            <div className="col-auto">
                <img src={item.imageUrl} className="w-h-164" />
            </div>
            <div className="col">

                <div className="row mb-8">
                    <div className="col">
                        <a href={item.fabricUrl} className="subtitle1 default-text" title={item.title}>{item.title}</a>
                    </div>
                    <div className="col-auto align-top mt-1">
                        <span className="curtains-icon curtains-icon-octicon_trash-24 size-24 gray pointer"
                            onClick={async () => {
                                if (confirm('Are you sure want to remove this product?')) {
                                    setloading(true);
                                    try { await actions.onDeleteItem(item) }
                                    finally { setloading(false) }
                                }
                            }}></span>
                    </div>
                </div>

                <div className="body-text3 active-group sm-text-14">
                    {
                        item.supplyOwnFabric === false ? (
                            <>
                                <div>
                                    <span className="gray">Collection: </span>
                                    <a href={item.collectionUrl} className="underline">{item.collectionName}</a>
                                </div>
                                { item.showMore && item.showMore !== '' && <ShowMoreContent content={item.showMore} /> }
                                <div>
                                    <span className="gray">Colour:</span> {item.colour || 'None'}
                                </div>
                            </>
                        )
                        : (
                            <>
                                { item.showMore && item.showMore !== '' && <ShowMoreContent content={item.showMore} /> }
                            </>
                        )
                    }
                    <div>
                        <span className="gray">Qty: {item.quantityUnitPrice}</span>
                    </div>
                </div>

                <div className="body-text4 mt-8">{formatCurrency(item.price)}</div>

                <div className="d-flex gap-32 mt-16 body-text3 color-bg2">
                    <span className="underline pointer"
                        onClick={async () => {
                            setloading(!loading);
                            try { await actions.onSaveForLater(item) }
                            catch  { setloading(false) }
                            finally { setloading(false) }
                        }}>Save for later</span>
                    {
                        item.productType === 100 ? <></> :
                        <span className="underline pointer show-btn hide-btn"
                            onClick={() => { setloading(!loading); actions.editFabricItem(item); setloading(false); }}
                            data-show="#item-edit-@index"
                            data-hide="#basket-main-content" data-no-activate="1">Edit</span>
                    }
                </div>
            </div>
        </div>
        <div className="dashed-line mt-32"></div>
    </Loader>;
}
